import { css } from "emotion";
import { Spinner, SpinnerSize } from "office-ui-fabric-react";
import React from "react";

/**
 * Props
 */
export interface LoadingProps {
  isLoading: boolean;
}

/**
 * ローディングインジケーター
 * @param props
 * @constructor
 */
export const Loading: React.FunctionComponent<LoadingProps> = props => {
  return (
    <div>
      {props.isLoading && (
        <div
          className={css`
            z-index: 10;
            width: 100vw;
            height: 100vh;
            position: fixed;
            display: grid;
            // background-color: rgba(255, 255, 255, 0.75);
          `}
        >
          <Spinner
            size={SpinnerSize.large}
            label={"読み込み中..."}
            labelPosition={"left"}
          />
        </div>
      )}
    </div>
  );
};
